<script lang="ts">
    import { onMount } from "svelte"
    import { postLogin } from "../api"
    import CardWrapper from "../lib/components/CardWrapper.svelte"
    import Cta from "../lib/components/CTA.svelte"
    import { validateInput, onChange, validateField } from "../lib/components/formComponents/helper"
    import Input from "../lib/components/formComponents/Input.svelte"
    import { location, login, newNotification } from "../lib/store"
    import { spaNavigate } from "../lib/actions"

    const loginDetails: {
        username: string
        password: string
        rememberLogin: boolean
    } = {
        username: "",
        password: "",
        rememberLogin: true,
    }
    onMount(() => {
        if ($location.path !== "/login" && !$login) {
            login.set(null)
            spaNavigate("/login")
        }
    })

    function loginUser() {
        const validations = [
            { id: "username", value: loginDetails.username, validator: validateInput },
            { id: "password", value: loginDetails.password, validator: validateInput },
        ]

        let isValid = true

        for (const { id, value, validator } of validations) {
            // @ts-ignore
            if (!validateField(id, value, validator)) isValid = false
        }
        if (isValid) {
            postLogin({
                username: loginDetails.username,
                password: loginDetails.password,
                rememberLogin: loginDetails.rememberLogin,
            })
                .then(() => {
                    newNotification({ html: "Login erfolgreich", class: "success" })
                    spaNavigate("/")
                })
                .catch((error) => {
                    console.log("error", error)
                    if (error.status === 403 || error.message.includes("token not"))
                        newNotification({ html: "Falscher Nutzername oder falsches Passwort.", class: "error" })
                    else newNotification({ html: "Ein Fehler ist aufgetreten.", class: "error" })
                })
        }
    }
    $: if (!!$login) {
        spaNavigate("/")
    }
</script>

<section class="small-wrapper">
    <CardWrapper
        icon="solar_login-outline.svg"
        title="Login"
    >
        <form
            class="login"
            on:submit|preventDefault|stopPropagation="{loginUser}"
        >
            <div class="content">
                <section class="details">
                    <Input
                        placeholder="Nutzername"
                        id="username"
                        onChange="{onChange}"
                        bind:value="{loginDetails.username}"
                    />
                    <Input
                        placeholder="Passwort"
                        id="password"
                        onChange="{onChange}"
                        bind:value="{loginDetails.password}"
                    />
                </section>
            </div>
            <section class="submit">
                <Input
                    type="checkbox"
                    id="remember"
                    placeholder="Angemeldet bleiben"
                    onChange="{onChange}"
                    bind:value="{loginDetails.rememberLogin}"
                />
                <Cta
                    type="primaryButton"
                    icon="solar_check-read-outline"
                    content="Login"
                    on:click
                />
            </section>
        </form>
    </CardWrapper>
</section>

<style lang="less">
    .small-wrapper {
        form {
            width: 100%;
            padding: 1.2rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 1.2rem;

            h2 {
                color: var(--text-invers-100);
            }
            .content {
                width: 100%;
                .details {
                    display: flex;
                    flex-direction: column;
                    gap: 1.2rem;
                    width: 100%;
                }
            }
            .submit {
                display: flex;
                justify-content: flex-start;
                gap: 1.2rem;
                width: 100%;
                button {
                    width: fit-content;
                }
            }
        }
    }
</style>
